/** Human inactivity, independent of transport health and short-lived issuer credentials. */
export const BROWSER_IDLE_MS = 30 * 60_000;
export const BROWSER_ACTIVITY_INTERVAL_MS = 5_000;
//# sourceMappingURL=browser-session.js.map